var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 22.8C22.295 22.8 20.6599 22.1679 19.4543 21.0426C18.2487 19.9174 17.5714 18.3913 17.5714 16.8C17.5714 15.2087 18.2487 13.6826 19.4543 12.5574C20.6599 11.4321 22.295 10.8 24 10.8C25.705 10.8 27.3401 11.4321 28.5457 12.5574C29.7513 13.6826 30.4286 15.2087 30.4286 16.8C30.4286 17.5879 30.2623 18.3681 29.9392 19.0961C29.6162 19.8241 29.1426 20.4855 28.5457 21.0426C27.9487 21.5998 27.2401 22.0417 26.4601 22.3433C25.6802 22.6448 24.8442 22.8 24 22.8ZM24 0C19.2261 0 14.6477 1.76999 11.2721 4.92061C7.89642 8.07122 6 12.3444 6 16.8C6 29.4 24 48 24 48C24 48 42 29.4 42 16.8C42 12.3444 40.1036 8.07122 36.7279 4.92061C33.3523 1.76999 28.7739 0 24 0Z",
    fill: "#ABE138"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map-icon.d52b108825805c2708be618842cfab09.svg";
export { ForwardRef as ReactComponent };